// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"579c2166","488":"9024a109"}[chunkId] + ".chunk.js";
};